import React from 'react'

const PageNotFound: React.FC = () => {
  return (
    <div className="d-flex justify-content-center align-items-center loader-container">
      <div
        className="no-data-container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <h1> 404 Page not found</h1>
      </div>
    </div>
  )
}
export default PageNotFound
